import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import useTabs from "@app/pages/samples/utils/useTab";
import { setsAnalysisPhasesIodo131 } from "@app/pages/samples/config/phases/AnalysisPhases";
import { useDefaultValuesData } from "../utils/useDefaultValuesData";
import { getDefaultValuesIodo } from "./getDefaultValues";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

const Iodo131Form = () => {
  const { tabValueAnalysis } = useTabs();
  const { idMuestra } = useParams();
  const { currentCounting } = useAnalysis();

  const form = useFormContext();
  const typeAnalysis = form.watch("typeAnalysis");
  const defaultPreloadValues = useDefaultValuesData(
    typeAnalysis,
    form.getValues("processing_date_time_end")
  );
  const currentPreparationObject = defaultPreloadValues.currentPreparationIndex;

  useEffect(() => {
    if (currentPreparationObject) {
      const currentValues = form.getValues();

      const newValues = {
        ...currentValues,
        ...getDefaultValuesIodo(defaultPreloadValues),
      };

      form.reset(newValues);
    }
  }, [idMuestra, JSON.stringify(currentPreparationObject), currentCounting]);

  const CurrentComponent =
    setsAnalysisPhasesIodo131[tabValueAnalysis]?.component;
  return CurrentComponent ? <CurrentComponent /> : null;
};

export default Iodo131Form;
